"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfManageDigestSportDto = instanceOfManageDigestSportDto;
exports.ManageDigestSportDtoFromJSON = ManageDigestSportDtoFromJSON;
exports.ManageDigestSportDtoFromJSONTyped = ManageDigestSportDtoFromJSONTyped;
exports.ManageDigestSportDtoToJSON = ManageDigestSportDtoToJSON;
exports.ManageDigestSportDtoToJSONTyped = ManageDigestSportDtoToJSONTyped;
var ManageDigestSectionDto_1 = require("./ManageDigestSectionDto");
/**
 * Check if a given object implements the ManageDigestSportDto interface.
 */
function instanceOfManageDigestSportDto(value) {
    if (!('sportCode' in value) || value['sportCode'] === undefined)
        return false;
    if (!('hidden' in value) || value['hidden'] === undefined)
        return false;
    if (!('sections' in value) || value['sections'] === undefined)
        return false;
    return true;
}
function ManageDigestSportDtoFromJSON(json) {
    return ManageDigestSportDtoFromJSONTyped(json, false);
}
function ManageDigestSportDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportCode': json['sportCode'],
        'hidden': json['hidden'],
        'sections': (json['sections'].map(ManageDigestSectionDto_1.ManageDigestSectionDtoFromJSON)),
    };
}
function ManageDigestSportDtoToJSON(json) {
    return ManageDigestSportDtoToJSONTyped(json, false);
}
function ManageDigestSportDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportCode': value['sportCode'],
        'hidden': value['hidden'],
        'sections': (value['sections'].map(ManageDigestSectionDto_1.ManageDigestSectionDtoToJSON)),
    };
}
